import { IHash } from "@/shared";
import { ConvertDateTimePeriod } from "./models/ConvertDateTimePeriod";
import { ConvertDateTimesRequest } from "./models/ConvertDateTimesRequest";
import { ConvertedDateTimeItem } from "./models/ConvertedDateTimeItem";

export const TokenITimeZoneHelperService = "ITimeZoneHelperService";

export interface ITimeZoneHelperService {
  ConvertDateTimes(request: ConvertDateTimesRequest): Promise<IHash<ConvertedDateTimeItem>>;
  ConvertToOrganizerTimeZone(datetime: Date): Promise<Date>;
  ConvertPeriodToOrganizerTimeZone(period: ConvertDateTimePeriod): Promise<ConvertDateTimePeriod>;
}
